module.exports = __webpack_public_path__ + "static/img/wechat.d7f6fbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/h5/wechat.png
// module id = +D66
// module chunks = 163